import React, { Component } from 'react';
import CodeSample from './CodeSample/CodeSample';
import * as Consts from '../constants';

export default class DeliveryPanel extends Component {
  render(){
    if (this.props.publicId) {
      return (
        <div className="container">
          <section className="well panel-generate" >
            <div className="heading text-center" ref={node => {this.headingElement = node;}}>
              <h2>On-the-fly image manipulation &amp; delivery </h2>
              <p>Select your preferred development platform to see sample image manipulation URLs and framework integration code</p>
            </div>
            <CodeSample transformation={{crop: 'fill', gravity: 'faces', width: 300, height: 200}} format="jpg" {...this.props} cloudName={Consts.CLOUD_NAME}/>
          </section>
        </div>
      );
    } else {
      return <div/>;
    }
  }
}


/** WEBPACK FOOTER **
 ** ./src/js/components/DeliveryPanel.js
 **/